import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface EssayCourseState {
  isWriting: boolean;
  setIsWriting: (status: boolean) => void;
  resetEssayCourse: () => void;
}

export const useEssayCourseStore = create<EssayCourseState>()(
  persist(
    (set) => ({
      isWriting: false,
      setIsWriting: (status: boolean) => set({ isWriting: status }),
      resetEssayCourse: () => set({
        isWriting: false,
      })
    }),
    {
      name: 'essay-course-state'
    }
  )
);
